import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Briefcase, FileText, CreditCard, LogOut, ShieldCheck } from 'lucide-react';
import { useAdminAuth } from '../context/AdminAuthContext';

const NAV_ITEMS = [
  { to: '/panel', label: 'Genel Bakış', icon: LayoutDashboard, end: true },
  { to: '/panel/adaylar', label: 'Adaylar', icon: Users },
  { to: '/panel/ilanlar', label: 'İlanlar', icon: Briefcase },
  { to: '/panel/basvurular', label: 'Başvurular', icon: FileText },
  { to: '/panel/abonelikler', label: 'Abonelikler', icon: CreditCard },
];

const AdminLayout = ({ title, children }) => {
  const { admin, logout } = useAdminAuth();
  const initial = (admin?.name || admin?.email || '?').trim().charAt(0).toUpperCase();

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          <ShieldCheck size={20} color="#FF6B35" />
          isBulsun <span className="badge">ADMIN</span>
        </div>

        <nav className="admin-nav">
          {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}
            >
              <Icon />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <button type="button" className="admin-logout-btn" onClick={logout}>
            <LogOut size={18} />
            Çıkış Yap
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-topbar">
          <div className="admin-topbar-title">{title}</div>
          <div className="admin-topbar-user">
            <span>{admin?.name || admin?.email}</span>
            <div className="admin-avatar">{initial}</div>
          </div>
        </header>

        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
